import { FormattedMessage } from 'react-intl';

export const TooLargeErrorAlert = (props: { hideAlert: () => void }) => {
    return (
        <div className="alert alert-dismissible alert-danger margin-bottom-20">
            <button
                type="button"
                className="btn btn-icon-only close"
                data-dismiss="alert"
                onClick={props.hideAlert}
                data-testid="close-alert"
            >
                <span className="rioglyph rioglyph-remove" />
            </button>
            <div className="display-flex gap-10">
                <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
                <div>
                    <strong className="text-size-16">
                        <FormattedMessage id="outboundOrderBook.export.tooLargeError.heading" />
                    </strong>
                    <div className="margin-y-5">
                        <FormattedMessage
                            id="outboundOrderBook.export.tooLargeError.description"
                            values={{ maxSize: 20000 }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
